/**
 * KYC登録状態
 */
export const KYC_FLG = {
  UNREGISTERED: 0, // 未登録
  APPROVAL: 1, // 許可
  PROCESSING: 2, // 確認中
  REJECTED: 3, // 却下
} as const;
